/* @flow */

export const IMAGE_UPDATED: string = 'calendar@images:IMAGE_UPDATED';
export const IMAGE_DELETED: string = 'calendar@images:IMAGE_DELETED';

export const updateImage = (image: CatalogResource) => ({
  type: IMAGE_UPDATED,
  image,
});

export const deleteImage = () => ({
  type: IMAGE_DELETED,
});



// WEBPACK FOOTER //
// ./src/modules/calendar/actions/images.js